import Fulllayout from '../layouts/fulllayout.js';
import Blanklayout from '../layouts/blanklayout.js';
import Modulelayout from "../layouts/modulelayout.js";
import Page404 from "../views/generic/page404";
import gxMaps from "../views/generic/gxMaps";

let indexRoutes = [
    { path: "/authentication", name: "Athentication", component: Blanklayout },
    { path: '/main', name: 'Dashboard', component: Fulllayout },
    { path: '/modules', name: 'Principal', component: Modulelayout},
    { path: '/404', name: 'Not found', component: Page404},
    { path: '/maps', name: 'Mapas', component: gxMaps},
];

export default indexRoutes;
